import React from 'react';
import CmsComplaint from '@components/pages/products/cms-complaint';

const CmsComplaintPage = () => <CmsComplaint />;

export default CmsComplaintPage;
